// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// import router from './router'
import VueRouter from 'vue-router'
import http from './http/index'
import './directive' //自定义指令

//视图导入
import bind from './view/bind.vue'
import newDaily from "./view/newDaily.vue"
import newMonthly from "./view/newMonthly.vue"
import newWeekly from "./view/newWeekly.vue"

//引入vant组件库
import Vant from 'vant';
import 'vant/lib/index.css';
// //二维码插件
// import VueQr from 'vue-qr';

// //chart插件
// import VeHistogram from 'v-charts/lib/histogram.common';
//MD5
import md5 from 'js-md5';
//引入打印工具
// import Vconsole from 'vconsole';
// new Vconsole();


Vue.use(Vant);
//使用路由
Vue.use(VueRouter);
// Vue.component(VeHistogram.name, VeHistogram)
//定义路由
//创建 router 实例
const  router = new VueRouter({
  // mode: "history", //去掉地址栏的#  隐藏则为hash模式
  routes : [
    { path: '/bind', component: bind },
    {path: '/newDaily', component: newDaily},
    {path: '/newMonthly', component: newMonthly},
    {path: '/newWeekly', component: newWeekly},
  ]
})



Vue.config.productionTip = false
Vue.prototype.$http = http.service;
Vue.prototype.$api = http.API;
Vue.prototype.$BASE = http.BASE_URL;
Vue.prototype.$md5 = md5;
/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js